import {SizeRunCluster, SizeTab} from './types';

const getClustersCount = ({
  activeFilters,
  clusters,
}: {
  activeFilters: Map<string, Array<string> | undefined>;
  clusters: Array<SizeRunCluster>;
}) => {
  return clusters.reduce((clusterAcc, cluster) => {
    const clusterCount =
      cluster.sizeRuns.reduce((sizeRunAcc, sizeRun) => {
        const activeSizeRunValues =
          (activeFilters.get(sizeRun.slug) || []).filter(value =>
            sizeRun.sizes.map(({id}) => id).includes(value),
          ).length ?? 0;

        return sizeRunAcc + activeSizeRunValues;
      }, 0) ?? 0;

    return clusterAcc + clusterCount;
  }, 0);
};

export const getActiveSizeFiltersCount = ({
  activeFilters,
  clusters,
  tabs,
}: {
  activeFilters: Map<string, Array<string> | undefined>;
  clusters?: Array<SizeRunCluster>;
  tabs?: SizeTab[];
}) => {
  if (clusters) {
    return getClustersCount({activeFilters, clusters});
  }

  if (tabs) {
    return tabs.reduce((tabAcc, tab, tabIndex) => {
      const tabSlug = tab.specialSizeFilter?.slug;
      const tabSlugActive = tabSlug && activeFilters.has(tabSlug);

      if (tab.clusters) {
        if (tabSlugActive) {
          const tabValue = activeFilters.get(tabSlug!)?.[0];
          const activeValue = tab.specialSizeFilter?.filterValueId;

          if (tabValue && activeValue && tabValue === activeValue) {
            return (
              tabAcc + getClustersCount({activeFilters, clusters: tab.clusters})
            );
          }
          return tabAcc;
        } else {
          if (tabIndex === 0) {
            return (
              tabAcc + getClustersCount({activeFilters, clusters: tab.clusters})
            );
          }
          return tabAcc;
        }
      }
      return tabAcc;
    }, 0);
  }

  return 0;
};
